import { Component, Input, OnInit } from '@angular/core';
import { getName as getCountryNameFromCode } from 'country-list';

const UNICODE_OFFSET = 127397;

interface CountryCodeAndFlag {
  flag: string;
  countryCode: string;
  countryName?: string;
}

@Component({
  selector: 'store-supported-countries-v2',
  templateUrl: './supported-countries-v2.component.html',
  styleUrls: ['./supported-countries-v2.component.scss'],
  standalone: false,
})
export class SupportedCountriesV2Component implements OnInit {
  @Input() businessCountryCode: string;
  @Input() set countryCodes(countryCodes: string[]) {
    this.countryCodeAndFlags = [];
    if (countryCodes) {
      countryCodes.forEach((countryCode) => {
        this.countryCodeAndFlags.push({
          flag: this.getEmojiFlag(countryCode),
          countryName: this.getCountryName(countryCode),
          countryCode,
        });
      });
    }
  }

  countryCodeAndFlags: CountryCodeAndFlag[] = [];
  businessCountry: CountryCodeAndFlag;
  availableInUserCountry = false;

  ngOnInit(): void {
    if (this.businessCountryCode && this.businessCountryCode.trim().length > 0) {
      this.businessCountry = {
        countryCode: this.businessCountryCode,
        flag: this.getEmojiFlag(this.businessCountryCode),
        countryName: this.getCountryName(this.businessCountryCode),
      };
    }
    this.availableInUserCountry = this.checkYourCountryInAvailable(this.businessCountryCode, this.countryCodeAndFlags);
    if (this.availableInUserCountry) {
      this.countryCodeAndFlags.unshift(this.businessCountry);
      for (let i = 1; i < this.countryCodeAndFlags.length; i++) {
        if (this.businessCountryCode === this.countryCodeAndFlags[i].countryCode) {
          this.countryCodeAndFlags.splice(i, 1);
        }
      }
    }
  }

  private getEmojiFlag(countryCode: string): string {
    const chars = [...countryCode.toUpperCase()].map((c) => c.charCodeAt(0) + UNICODE_OFFSET);
    return String.fromCodePoint(...chars);
  }

  private getCountryName(countryCode: string): string {
    if (!countryCode) {
      return '';
    }
    return getCountryNameFromCode(countryCode);
  }

  private checkYourCountryInAvailable(businessCountryCode: string, countryCodeAndFlags: CountryCodeAndFlag[]): boolean {
    let availableInUserCountry = false;
    if (
      businessCountryCode &&
      businessCountryCode.trim().length > 0 &&
      countryCodeAndFlags &&
      countryCodeAndFlags.length > 0
    ) {
      countryCodeAndFlags.forEach((countryCode) => {
        if (businessCountryCode === countryCode.countryCode) {
          availableInUserCountry = true;
        }
      });
    }
    return availableInUserCountry;
  }
}
